function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.11,
    height: 9.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.352857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 4.735
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.47,
    width: 23.11,
    height: 12.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 15.535
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.6,
    width: 23.11,
    height: 20.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4499999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 31.950000000000003
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.3,
    width: 23.11,
    height: 23.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 54.184999999999995
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.07,
    width: 23.11,
    height: 25.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 78.97999999999999
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.89,
    width: 23.11,
    height: 26.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5677777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 104.92
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.95,
    width: 23.11,
    height: 26.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 131.39000000000001
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.83,
    width: 23.11,
    height: 27.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 158.54000000000002
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.25,
    width: 23.11,
    height: 28.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 186.62
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 200.99,
    width: 23.11,
    height: 31.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.311
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 216.96
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 232.93,
    width: 23.11,
    height: 32.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.311
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 249.025
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 265.12,
    width: 23.11,
    height: 33.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.301428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 281.695
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 298.27,
    width: 23.11,
    height: 36.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 316.765
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335.27,
    width: 23.11,
    height: 38.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.88875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 354.625
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 373.98,
    width: 23.11,
    height: 39.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 393.495
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.01,
    width: 23.11,
    height: 40.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 433.025
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 453.04,
    width: 23.11,
    height: 47.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 476.88
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 500.72,
    width: 23.11,
    height: 48.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 524.73
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 548.75,
    width: 23.11,
    height: 48.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 572.82
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 596.89,
    width: 23.11,
    height: 51.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.301428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 622.5649999999999
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 648.24,
    width: 23.11,
    height: 51.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.555,
    y: 674.12
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 0,
    width: 30.73,
    height: 39.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.475,
    y: 19.695
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.84,
    y: 0,
    width: 30.86,
    height: 39.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.805454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.27000000000001,
    y: 19.695
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.7,
    y: 0,
    width: 30.89,
    height: 39.39,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.86125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.14500000000001,
    y: 19.695
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.58,
    y: 0,
    width: 31.3,
    height: 39.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4714285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.23,
    y: 19.695
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.89,
    y: 0,
    width: 31.95,
    height: 39.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.86499999999998,
    y: 19.695
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.84,
    y: 0,
    width: 32.38,
    height: 39.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2380000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.03,
    y: 19.695
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.22,
    y: 0,
    width: 36.24,
    height: 39.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.34,
    y: 19.695
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.46,
    y: 0,
    width: 36.38,
    height: 39.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.65000000000003,
    y: 19.695
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.84,
    y: 0,
    width: 37.93,
    height: 39.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.80499999999995,
    y: 19.695
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 0,
    width: 41.16,
    height: 39.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.92375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.34999999999997,
    y: 19.695
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.93,
    y: 0,
    width: 44.94,
    height: 39.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.4,
    y: 19.695
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.87,
    y: 0,
    width: 45.04,
    height: 39.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.39,
    y: 19.695
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.91,
    y: 0,
    width: 48.65,
    height: 39.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.627142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.235,
    y: 19.695
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.55,
    y: 0,
    width: 48.72,
    height: 39.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.91,
    y: 19.695
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.27,
    y: 0,
    width: 49.69,
    height: 39.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.115,
    y: 19.695
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.96,
    y: 0,
    width: 49.97,
    height: 39.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.878
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.945,
    y: 19.695
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.94,
    y: 0,
    width: 50.06,
    height: 39.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.97,
    y: 19.695
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 39.39,
    width: 50.8,
    height: 39.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.9375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 59.265
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 79.14,
    width: 50.8,
    height: 40.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.068
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 99.48
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 119.82,
    width: 50.8,
    height: 41.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.12875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 140.33499999999998
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 160.85,
    width: 50.8,
    height: 41.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 181.815
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 202.78,
    width: 50.8,
    height: 43.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 224.33
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 245.87,
    width: 50.8,
    height: 44.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 268.12
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 290.37,
    width: 50.8,
    height: 45.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 313.12
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 335.87,
    width: 50.8,
    height: 46.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 359.32
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 382.77,
    width: 50.8,
    height: 48.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 407.07
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 431.38,
    width: 50.8,
    height: 51.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 457.295
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 483.2,
    width: 50.8,
    height: 53.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 509.805
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 536.41,
    width: 50.8,
    height: 53.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 563.03
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 589.65,
    width: 50.8,
    height: 54.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 617.0749999999999
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.11,
    y: 644.5,
    width: 50.8,
    height: 55.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.644444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.51,
    y: 672.25
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 39.39,
    width: 51.25,
    height: 55.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.321428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.535,
    y: 67
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.16,
    y: 39.39,
    width: 53.71,
    height: 55.22,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.967777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.015,
    y: 67
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.87,
    y: 39.39,
    width: 53.72,
    height: 55.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.674285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.73000000000002,
    y: 67
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.6,
    y: 39.39,
    width: 55.01,
    height: 55.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.87625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.105,
    y: 67
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.6,
    y: 39.39,
    width: 55.15,
    height: 55.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.191666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.175,
    y: 67
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.75,
    y: 39.39,
    width: 58.26,
    height: 55.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.888571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.88,
    y: 67
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.01,
    y: 39.39,
    width: 58.74,
    height: 55.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.888571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.38,
    y: 67
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.76,
    y: 39.39,
    width: 58.79,
    height: 55.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.155,
    y: 67
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.55,
    y: 39.39,
    width: 59.26,
    height: 55.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.522
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.18,
    y: 67
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.81,
    y: 39.39,
    width: 60.84,
    height: 55.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 608.2299999999999,
    y: 67
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.65,
    y: 39.39,
    width: 61.35,
    height: 55.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.3249999999999,
    y: 67
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 94.61,
    width: 62.9,
    height: 59.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.522857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 124.44
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 154.27,
    width: 62.9,
    height: 62.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 185.52
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 216.77,
    width: 62.9,
    height: 63.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 248.63
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 280.49,
    width: 62.9,
    height: 65.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.985714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 313.02
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 345.56,
    width: 62.9,
    height: 67.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 379.13
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 412.7,
    width: 62.9,
    height: 69.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 447.57
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 482.44,
    width: 62.9,
    height: 72.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.985714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 518.485
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 554.53,
    width: 62.9,
    height: 72.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 590.65
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.91,
    y: 626.76,
    width: 62.9,
    height: 73.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.985714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.36,
    y: 663.38
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 94.61,
    width: 60.57,
    height: 77.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.105,
    y: 133.275
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.38,
    y: 94.61,
    width: 64.68,
    height: 77.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.186666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.72,
    y: 133.275
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.07,
    y: 94.61,
    width: 66.86,
    height: 77.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.372
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.5,
    y: 133.275
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.93,
    y: 94.61,
    width: 69.64,
    height: 77.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.75,
    y: 133.275
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.57,
    y: 94.61,
    width: 73.5,
    height: 77.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.32,
    y: 133.275
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.08,
    y: 94.61,
    width: 73.65,
    height: 77.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.905,
    y: 133.275
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.73,
    y: 94.61,
    width: 76.47,
    height: 77.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.496666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.965,
    y: 133.275
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.2,
    y: 94.61,
    width: 77.8,
    height: 77.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.592222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.1,
    y: 133.275
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 171.95,
    width: 84.71,
    height: 78.05,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.75625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.17499999999998,
    y: 210.975
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 250,
    width: 84.71,
    height: 82.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.17499999999998,
    y: 291.475
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 332.95,
    width: 84.71,
    height: 86.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.17499999999998,
    y: 376.04499999999996
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 419.14,
    width: 84.71,
    height: 92.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.17499999999998,
    y: 465.205
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 511.26,
    width: 84.71,
    height: 93.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.10142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.17499999999998,
    y: 558.085
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.82,
    y: 604.92,
    width: 84.71,
    height: 95.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.58875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.17499999999998,
    y: 652.4599999999999
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 171.95,
    width: 91.2,
    height: 91.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.028571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.13,
    y: 217.76999999999998
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.73,
    y: 171.95,
    width: 92.17,
    height: 91.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.815,
    y: 217.76999999999998
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.9,
    y: 171.95,
    width: 93.58,
    height: 91.64,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.273333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.69,
    y: 217.76999999999998
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.48,
    y: 171.95,
    width: 96.43,
    height: 91.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.695,
    y: 217.76999999999998
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.91,
    y: 171.95,
    width: 105.09,
    height: 91.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.273333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.4549999999999,
    y: 217.76999999999998
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 263.58,
    width: 114.24,
    height: 86.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.65,
    y: 306.59
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 349.61,
    width: 114.24,
    height: 99.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.086363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.65,
    y: 399.58500000000004
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 449.56,
    width: 114.24,
    height: 123.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.65,
    y: 511.415
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 573.26,
    width: 114.24,
    height: 126.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.424
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.65,
    y: 636.63
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 263.58,
    width: 90.98,
    height: 170.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.163333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.26,
    y: 348.89
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.76,
    y: 263.58,
    width: 111.16,
    height: 170.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.879999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.34,
    y: 348.89
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.92,
    y: 263.58,
    width: 162.08,
    height: 170.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.9599999999999,
    y: 348.89
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 434.21,
    width: 176.3,
    height: 265.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.027272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.91999999999996,
    y: 567.105
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.07,
    y: 434.21,
    width: 187.93,
    height: 265.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 46.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.0350000000001,
    y: 567.105
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2008);
export default __webpack_public_path__ + "static/media/2008.eebb3aa6064fdcc965ab50639a727c01.svg";
export { ForwardRef as ReactComponent };